import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'

import RediscoverHeaderComponent from './RediscoverHeaderComponent'
import RediscoverOnBoarding from './RediscoverOnBoarding'
import Dashboard from './Dashboard'
import Spinner from '../Spinner'
import NotFound from '../NotFound'

import './RediscoverComponent.scss'

export default class RediscoverComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    history: PropTypes.object,
    homepage: PropTypes.object,
    topicId: PropTypes.string,
    entities: PropTypes.object,
    genreDemo: PropTypes.object,
    demoSummary: PropTypes.object,
    rediscoverNetwork: PropTypes.object,
    fetchNetworkEntities: PropTypes.func.isRequired,
    setRediscoverSelectedGenre: PropTypes.func.isRequired,
    setRediscoverSelectedGenreNetwork: PropTypes.func.isRequired,
    fetchGenreDemo: PropTypes.func.isRequired,
    fetchGenreDemoSummary: PropTypes.func.isRequired
  }

  constructor (props){
    super(props)
    this.state = {
        selectedNetwork: '',
        thumbnails: []
    }
  }

  componentDidMount () {
    document.body.classList.add('rediscoverBody')
    if (this.props.topicId && this.props.homepage.details) {
      this.setNetwork()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.topicId !== this.props.topicId && this.props.topicId && this.props.homepage.details) {
      this.setNetwork()
    }
  }

  setNetwork = () => {
    const networkEntity = this.props.homepage.details.discover_entities.filter(e => e.entity_id === this.props.topicId)
    const network = networkEntity.length > 0 ? networkEntity[0].network_label : ''
    this.setState({ selectedNetwork: network })
  }

  setSelectedNetwork = () => {
    const selectedNetwork = this.props.homepage.details && this.props.homepage.details.discover_entities.filter(e => e.is_default)[0].network_label
      this.setState({ selectedNetwork: selectedNetwork })
  }

  updateSelectedNetwork = (network) => {
    this.setState({ selectedNetwork: network })
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for <strong>{this.state.selectedNetwork}</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    const name = 'Discover Tour'
    return (
      <RediscoverOnBoarding
        name={name}
        run={true}
        selectedNetwork={this.state.selectedNetwork}
      />
    )
  }

  render () {
    if (!this.props.homepage.details && !this.props.shortcut) {
      return (<Spinner />)
    }

    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.discover_entities && this.props.homepage.details.discover_entities.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    const primaryNetwork = this.state.selectedNetwork

    return (
      <div className="rightSide whiteBg">
        <Container fluid={true} className="rediscover">
          {this._renderShortcut()}
          {this._renderOnboarding()}
          <RediscoverHeaderComponent
            homepage={this.props.homepage}
            history={this.props.history}
            shortcut={this.props.shortcut}
            selectedNetwork={this.state.selectedNetwork}
            updateSelectedNetwork={this.updateSelectedNetwork}
          />
          <Row>
            <Col>
              <Dashboard
                selectedNetwork={primaryNetwork}
                fetchNetworkEntities={this.props.fetchNetworkEntities}
                fetchGenreDemo={this.props.fetchGenreDemo}
                fetchGenreDemoSummary={this.props.fetchGenreDemoSummary}
                entities={this.props.entities}
                genreDemo={this.props.genreDemo}
                demoSummary={this.props.demoSummary}
                setRediscoverSelectedGenre={this.props.setRediscoverSelectedGenre}
                setRediscoverSelectedGenreNetwork={this.props.setRediscoverSelectedGenreNetwork}
                />
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}